/* eslint react/no-is-mounted:0,react/sort-comp:0,react/prop-types:0 */
/*
 * base-upload
 * author zhousheng
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import classNames from 'classnames';
import pickAttrs from 'rc-util/lib/pickAttrs';
import defaultRequest from './request';
import getUid from './uid';
import attrAccept from './attr-accept';
import traverseFileTree from './traverseFileTree';
class AjaxUploader extends Component {
    constructor() {
        super(...arguments);
        this.state = { uid: getUid() };
        this.reqs = {};
        this.onChange = (e) => {
            const { accept, directory } = this.props;
            const { files } = e.target;
            const acceptedFiles = [...files].filter((file) => !directory || attrAccept(file, accept));
            this.uploadFiles(acceptedFiles);
            this.reset();
        };
        this.onClick = (e) => {
            const el = this.fileInput;
            if (!el) {
                return;
            }
            const { children, onClick } = this.props;
            if (children && children.type === 'button') {
                const parent = el.parentNode;
                parent.focus();
                parent.querySelector('button').blur();
            }
            el.click();
            if (onClick) {
                onClick(e);
            }
        };
        this.onKeyDown = (e) => {
            if (e.key === 'Enter') {
                this.onClick(e);
            }
        };
        this.onFileDrop = (e) => {
            const { multiple } = this.props;
            e.preventDefault();
            if (e.type === 'dragover') {
                return;
            }
            if (this.props.directory) {
                traverseFileTree(Array.prototype.slice.call(e.dataTransfer.items), this.uploadFiles, (_file) => attrAccept(_file, this.props.accept));
            }
            else {
                let files = [...e.dataTransfer.files].filter((file) => attrAccept(file, this.props.accept));
                if (multiple === false) {
                    files = files.slice(0, 1);
                }
                this.uploadFiles(files);
            }
        };
        this.uploadFiles = (files) => {
            const originFiles = [...files];
            const postFiles = originFiles.map((file) => {
                // eslint-disable-next-line no-param-reassign
                // 处理重新上传文件时已有uid的情况
                file.uid = (file === null || file === void 0 ? void 0 : file.uid) || getUid();
                return this.processFile(file, originFiles);
            });
            // Batch upload files
            Promise.all(postFiles).then(fileList => {
                const { onBatchStart } = this.props;
                onBatchStart === null || onBatchStart === void 0 ? void 0 : onBatchStart(fileList.map(({ origin, parsedFile }) => ({ file: origin, parsedFile })));
                fileList
                    .filter(file => file.parsedFile !== null)
                    .forEach(file => {
                    this.post(file);
                });
            });
        };
        /**
         * Process file before upload. When all the file is ready, we start upload.
         */
        this.processFile = (file, fileList) => __awaiter(this, void 0, void 0, function* () {
            const { beforeUpload } = this.props;
            let transformedFile = file;
            if (beforeUpload) {
                try {
                    transformedFile = yield beforeUpload(file, fileList);
                }
                catch (e) {
                    // Rejection will also trade as false
                    transformedFile = false;
                }
                if (transformedFile === false) {
                    return {
                        origin: file,
                        parsedFile: null,
                        action: null,
                        data: null
                    };
                }
            }
            // Get latest action
            const { action } = this.props;
            let mergedAction;
            if (typeof action === 'function') {
                mergedAction = yield action(file);
            }
            else {
                mergedAction = action;
            }
            // Get latest data
            const { data } = this.props;
            let mergedData;
            if (typeof data === 'function') {
                mergedData = yield data(file);
            }
            else {
                mergedData = data;
            }
            const parsedData 
            // string type is from legacy `transformFile`.
            // Not sure if this will work since no related test case works with it
            = (typeof transformedFile === 'object' || typeof transformedFile === 'string')
                && transformedFile
                ? transformedFile
                : file;
            let parsedFile;
            if (parsedData instanceof File) {
                parsedFile = parsedData;
            }
            else {
                parsedFile = new File([parsedData], file.name, { type: file.type });
            }
            const mergedParsedFile = parsedFile;
            mergedParsedFile.uid = file.uid;
            return {
                origin: file,
                data: mergedData,
                parsedFile: mergedParsedFile,
                action: mergedAction
            };
        });
        this.saveFileInput = (node) => {
            this.fileInput = node;
        };
    }
    componentDidMount() {
        this._isMounted = true;
    }
    componentWillUnmount() {
        this._isMounted = false;
        this.abort();
    }
    post({ data, origin, action, parsedFile }) {
        if (!this._isMounted) {
            return;
        }
        const { onStart, customRequest, name, headers, withCredentials, method } = this.props;
        const { uid } = origin;
        const request = customRequest || defaultRequest;
        const requestOption = {
            action,
            filename: name,
            data,
            file: parsedFile,
            headers,
            withCredentials,
            method: method || 'post',
            onProgress: (e) => {
                const { onProgress } = this.props;
                onProgress === null || onProgress === void 0 ? void 0 : onProgress(e, parsedFile);
            },
            onSuccess: (ret, xhr) => {
                const { onSuccess } = this.props;
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(ret, parsedFile, xhr);
                delete this.reqs[uid];
            },
            onError: (err, ret) => {
                const { onError } = this.props;
                onError === null || onError === void 0 ? void 0 : onError(err, ret, parsedFile);
                delete this.reqs[uid];
            }
        };
        onStart(origin);
        this.reqs[uid] = request(requestOption);
    }
    reset() {
        this.setState({
            uid: getUid(),
        });
    }
    abort(file) {
        const { reqs } = this;
        if (file) {
            const uid = file.uid ? file.uid : file;
            if (reqs[uid] && reqs[uid].abort) {
                reqs[uid].abort();
            }
            delete reqs[uid];
        }
        else {
            Object.keys(reqs).forEach(uid => {
                if (reqs[uid] && reqs[uid].abort) {
                    reqs[uid].abort();
                }
                delete reqs[uid];
            });
        }
    }
    render() {
        const _a = this.props, { component: Tag, prefixCls, className, disabled, id, style, multiple, accept, capture, children, directory, openFileDialogOnClick, onMouseEnter, onMouseLeave } = _a, otherProps = __rest(_a, ["component", "prefixCls", "className", "disabled", "id", "style", "multiple", "accept", "capture", "children", "directory", "openFileDialogOnClick", "onMouseEnter", "onMouseLeave"]);
        const cls = classNames({
            [prefixCls]: true,
            [`${prefixCls}-disabled`]: disabled,
            [className]: className
        });
        // because input don't have directory/webkitdirectory type declaration
        const dirProps = directory
            ? { directory: 'directory', webkitdirectory: 'webkitdirectory' }
            : {};
        const events = disabled
            ? {}
            : {
                onClick: openFileDialogOnClick ? this.onClick : () => { },
                onKeyDown: openFileDialogOnClick ? this.onKeyDown : () => { },
                onMouseEnter,
                onMouseLeave,
                onDrop: this.onFileDrop,
                onDragOver: this.onFileDrop,
                tabIndex: '0',
            };
        return (<Tag {...events} className={cls} role="button" disabled={disabled} style={style}>
                <input {...pickAttrs(otherProps, { aria: true, data: true })} id={id} type="file" ref={this.saveFileInput} onClick={e => e.stopPropagation()} key={this.state.uid} style={{ display: 'none' }} accept={accept} {...dirProps} multiple={multiple} onChange={this.onChange} {...(capture != null ? { capture } : {})}/>
                {children}
            </Tag>);
    }
}
export default AjaxUploader;
